import { useHistory } from 'react-router-dom'
import useContact from '@hooks/useContact'

export default function useSimulationPermission() {
  const { contact } = useContact()
  const history = useHistory()

  if (!contact.id) {
    history.push('/')
  }
}
